import React from 'react'
import { Button, DropdownItem, Icon, Popover } from 'gu-ui-kit'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { actionConfirmInterrupt, actionStartTrack } from 'modules/Onboarding/store/actions'
import { ROUTES } from 'constants/routes'
import { selectAppLocale } from 'modules/App/store/selectors'
import { selectIsOnboardingRunning } from 'modules/Onboarding/store/selectors'
import { buildLandingPath } from 'utils/buildLandingPath'
import PropTypes from 'prop-types'

const FaqMenu = ({ className }) => {
  const { bindTrigger, bindPopover, usePopupState } = Popover.usePopover()
  const dispatch = useDispatch()
  const locale = useSelector(selectAppLocale)
  const { t } = useTranslation(['onboarding'])
  const isOnboardingRunning = useSelector(selectIsOnboardingRunning)

  const popoverState = usePopupState({
    variant: 'popover',
    id: 'faqMenuDropdown',
  })

  return (
    <>
      <Button
        {...bindTrigger(popoverState)}
        className={className}
        variant={'ghost'}
        grey
        size={'s'}
        startIcon={<Icon name={'question'} />}
        noLabel
      />
      <Popover
        {...bindPopover(popoverState)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 24,
          horizontal: 'left',
        }}
        breakpoints={{
          0: {
            variant: 'bottomSheet',
            hasBackdrop: true,
          },
          768: {
            variant: 'popover',
            hasBackdrop: false,
          },
        }}
      >
        <DropdownItem
          size={'m'}
          startIcon={
            <Icon
              width={20}
              name="question"
            />
          }
          onClick={() => {
            popoverState.close()
            window.open(buildLandingPath(locale, ROUTES.FAQ), '_blank', 'noopener,noreferrer')
          }}
        >
          {t('common::user_menu.help')}
        </DropdownItem>

        <DropdownItem
          size={'m'}
          onClick={() => {
            popoverState.close()
            if (isOnboardingRunning) {
              dispatch(actionConfirmInterrupt())
            } else {
              dispatch(actionStartTrack('welcome'))
            }
          }}
          startIcon={
            <Icon
              width={20}
              name="learning"
            />
          }
        >
          {isOnboardingRunning
            ? t('onboarding::menu.finish_learning')
            : t('onboarding::menu.start_learning')}
        </DropdownItem>
      </Popover>
    </>
  )
}

export default FaqMenu

FaqMenu.propTypes = {
  className: PropTypes.string,
}
